/**
 * MG_WRITEOFF: количество в списании — как его видит человек.
 *
 * Бэкенд отдаёт Decimal строкой, и приходит «200.00» или «1.00». Хвостовые
 * нули не несут смысла: в холодильнике лежит одно яйцо, а не «1.00 яйца».
 * Лежит эта мелочь отдельно от компонентов, потому что нужна в двух местах —
 * в итоге «Приготовил» и в окне расхода, — а разошедшееся форматирование в
 * соседних окнах выглядит как разные числа.
 */
export function fmtWriteOffQty(raw: unknown): string {
  const s = String(raw ?? '');
  if (!s.includes('.')) return s;
  // Только дробную часть: «1000» остаётся «1000», а не превращается в «1».
  return s.replace(/\.?0+$/, '');
}
